import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { PreviewCarousel } from '../components/sales/PreviewCarousel';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { TransformationSection } from '../components/sales/TransformationSection';
import { DifferenceSection } from '../components/sales/DifferenceSection';
import { ValueStackSection } from '../components/sales/ValueStackSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalCloseSection } from '../components/sales/FinalCloseSection';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-night font-body text-brand-ink" data-id="element-175" data-mp="3vna2ezo64tgt">
      <main data-id="element-176" data-mp="3ajqb0w8tqd8x">
        <HeroSection data-id="element-177" data-mp="3ak8diam2xnpa" />
        <PreviewCarousel data-id="element-178" data-mp="3akrthls6620o" />
        <PainSection data-id="element-179" data-mp="3al1d8rmmfcxx" />
        <SolutionSection data-id="element-180" data-mp="3aljds0gbgdbn" />
        <VolumesSection data-id="element-181" data-mp="35shxpp4di7qh" />
        <BonusesSection data-id="element-182" data-mp="35s8842n8q2lb" />
        <TransformationSection data-id="element-183" data-mp="35qx3k0lz0qt5" />
        <DifferenceSection data-id="element-184" data-mp="30tnggrm20r8h" />
        <ValueStackSection data-id="element-185" data-mp="30uyj2o3rjsy0" />
        <AudienceSection data-id="element-186" data-mp="30u6n3c697t77" />
        <FaqSection data-id="element-187" data-mp="2vuu3r1eld49d" />
        <FinalCloseSection data-id="element-188" data-mp="2vvc5gdk0waoo" />
      </main>

      <footer className="border-t border-white/10 bg-brand-night px-5 py-10 text-center text-white/60" data-id="element-189" data-mp="2vweush1p652h">
        <p className="text-sm" data-id="element-190" data-mp="3tht1zgkxmk9d">© 2026 Astrologer Ready by Prof. Kyra · profkyra@gmail.com</p>
        <p className="mx-auto mt-4 max-w-3xl text-xs leading-relaxed text-white/45" data-id="element-191" data-mp="3ok13g3ps7zw7">
          Astrologer Ready is an educational and professional-workflow resource for astrologers and readers. It does not present astrology as scientifically proven and does not guarantee specific life, financial or business outcomes.
        </p>
      </footer>

    </div>;
}